function QuizNudge_GetStorageKey( popup )
{
    var key = popup.getAttribute( "data-storage-key" ) || "";

    return key;
}

function QuizNudge_IsDismissed( key )
{
    var seen = false;

    if ( key != "" )
    {
        try
        {
            seen = window.localStorage.getItem( key ) != null;
        }
        catch ( err )
        {
            seen = false;
        }
    }

    return seen;
}

// Persistent per-customer dismissal mirrors my-aisle-delivery-change-popup; session-only would re-nag every visit.
function QuizNudge_SetDismissed( key )
{
    if ( key == "" )
    {
        return;
    }

    try
    {
        window.localStorage.setItem( key, "1" );
    }
    catch ( err )
    {
    }
}

function QuizNudge_ClosePopup( popup, key, persist )
{
    popup.classList.add( "is-hidden" );
    popup.setAttribute( "aria-hidden", "true" );
    document.body.style.overflow = "";
    document.body.classList.remove( "quiz-nudge-open" );

    if ( persist )
    {
        QuizNudge_SetDismissed( key );
    }

    var cta = popup.querySelector( ".js-my-aisle-quiz-nudge-cta" );

    if ( cta )
    {
        cta.blur();
    }
}

function QuizNudge_OpenPopup( popup )
{
    popup.classList.remove( "is-hidden" );
    popup.setAttribute( "aria-hidden", "false" );
    document.body.style.overflow = "hidden";
    document.body.classList.add( "quiz-nudge-open" );

    var cta = popup.querySelector( ".js-my-aisle-quiz-nudge-cta" );

    if ( cta )
    {
        cta.focus();
    }
}

function QuizNudge_BindClose( popup, key, trigger )
{
    trigger.addEventListener( "click", function QuizNudge_CloseClick()
    {
        QuizNudge_ClosePopup( popup, key, true );
    } );
}

function QuizNudge_ResumeBannerVisible()
{
    var banners = document.querySelectorAll( ".quiz-resume-banner" );
    var visible = false;
    var i = 0;

    for ( i = 0; i < banners.length; i++ )
    {
        if ( banners[ i ].style.display != "none" )
        {
            visible = true;
        }
    }

    return visible;
}

function InitMyAisleQuizNudge()
{
    var popup = document.querySelector( ".js-my-aisle-quiz-nudge-popup" );
    var key = "";
    var closers = [];
    var i = 0;

    if ( !popup )
    {
        return;
    }

    if ( QuizNudge_ResumeBannerVisible() )
    {
        popup.remove();
        return;
    }

    key = QuizNudge_GetStorageKey( popup );

    if ( QuizNudge_IsDismissed( key ) )
    {
        popup.remove();
        return;
    }

    closers = popup.querySelectorAll( ".js-my-aisle-quiz-nudge-close" );

    for ( i = 0; i < closers.length; i++ )
    {
        QuizNudge_BindClose( popup, key, closers[ i ] );
    }

    document.addEventListener( "keydown", function QuizNudge_Escape( e )
    {
        if ( ( e.key == "Escape" ) && !popup.classList.contains( "is-hidden" ) )
        {
            QuizNudge_ClosePopup( popup, key, true );
        }
    } );

    QuizNudge_OpenPopup( popup );
}

window.addEventListener( "load", InitMyAisleQuizNudge );
